<template>
    <div class="activo-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="750" scrollable>
                    <v-card>
                        <v-toolbar card prominent color="primary" dark dense>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa fa-close</v-icon>
                            </v-btn>
                            <template slot="extension">
                                <v-tabs color="primary darken-1" dark grow slider-color="yellow" v-model="activeTab">
                                    <v-tab :key="1" :href="`#tab-1`">
                                        Generales
                                    </v-tab>
                                    <v-tab :key="2" :href="`#tab-2`">
                                        Ubicación
                                    </v-tab>
                                    <v-tab :key="3" :href="`#tab-3`">
                                        Clasificación
                                    </v-tab>
                                    <v-tab :key="4" :href="`#tab-4`">
                                        Responsable
                                    </v-tab>
                                </v-tabs>
                            </template>
                        </v-toolbar>
                        <v-flex>
                            <div slot="widget-content">
                                <v-alert
                                    v-model="showErrorAlert"
                                    type="error"
                                    dismissible
                                    transition="scale-transition"
                                    dark
                                >
                                    Existen errores de validación, revise los datos e intente nuevamente
                                </v-alert>
                                <v-alert
                                    v-model="showErrorDataLoadedAlert"
                                    type="error"
                                    dismissible
                                    transition="scale-transition"
                                    dark
                                >
                                    No se han podido cargar todos los datos necesarios para este formulario, intente
                                    cargar el formulario nuevamente.
                                </v-alert>
                            </div>
                        </v-flex>
                        <v-card-text>
                            <v-form ref="activoForm" v-model="validActivo">
                                <v-tabs-items v-model="activeTab">
                                    <v-tab-item :key="1" :value="`tab-1`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="activoItem.codigo"
                                                        label="Código*"
                                                        :counter="30"
                                                        :rules="codigoFieldRules"
                                                        :error-messages="codigoFieldErrors"
                                                        @blur="codigoFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="activoItem.marca"
                                                        label="Marca"
                                                        :counter="255"
                                                        :error-messages="marcaFieldErrors"
                                                        @blur="marcaFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="activoItem.modelo"
                                                        label="Modelo"
                                                        :counter="255"
                                                        :error-messages="modeloFieldErrors"
                                                        @blur="modeloFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="activoItem.serie"
                                                        label="Serie"
                                                        :counter="255"
                                                        :error-messages="serieFieldErrors"
                                                        @blur="serieFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="activoItem.descripcion"
                                                        label="Descripción*"
                                                        :counter="255"
                                                        :rules="descripcionFieldRules"
                                                        :error-messages="descripcionFieldErrors"
                                                        @blur="descripcionFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-menu
                                                        ref="menuFechaIngreso"
                                                        v-model="menuFechaIngreso"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        lazy
                                                        transition="scale-transition"
                                                        offset-y
                                                        full-width
                                                        min-width="290px"
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field
                                                                v-model="computedFechaIngresoFormatted"
                                                                label="Fecha de ingreso*"
                                                                v-on="on"
                                                                readonly
                                                                :error-messages="fecha_ingresoFieldErrors"
                                                                @blur="
                                                                    dateFecha_ingreso = parseDate(
                                                                        activoItem.fecha_ingreso
                                                                    )
                                                                "
                                                            >
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="dateFecha_ingreso"
                                                            no-title
                                                            scrollable
                                                            locale="es-es"
                                                            @input="menuFechaIngreso = false"
                                                        >
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-menu
                                                        ref="menuFechaBaja"
                                                        v-model="menuFechaBaja"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        lazy
                                                        transition="scale-transition"
                                                        offset-y
                                                        full-width
                                                        min-width="290px"
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field
                                                                v-model="computedFechaBajaFormatted"
                                                                label="Fecha de baja"
                                                                clearable
                                                                v-on="on"
                                                                readonly
                                                                :error-messages="fecha_bajaFieldErrors"
                                                                @blur="
                                                                    dateFecha_baja = parseDate(activoItem.fecha_baja)
                                                                "
                                                            >
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="dateFecha_baja"
                                                            no-title
                                                            scrollable
                                                            locale="es-es"
                                                            @input="menuFechaBaja = false"
                                                        >
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="activoItem.costo"
                                                        label="Costo"
                                                        :counter="255"
                                                        :error-messages="costoFieldErrors"
                                                        @blur="costoFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <label for="file-upload" class="v-btn" style="cursor: pointer">
                                                        <v-icon class="pr-1">fa fa-cloud-upload</v-icon> Imagen
                                                    </label>
                                                    <input
                                                        ref="file"
                                                        id="file-upload"
                                                        type="file"
                                                        accept="image/*"
                                                        @change="onChangeFileUpload()"
                                                    />
                                                    <br />
                                                    <div class="error_message">
                                                        {{ imagenFieldErrors[0] }}
                                                    </div>
                                                    {{
                                                        activoItem.imagen.length === 0
                                                            ? "Seleccione una imagen..."
                                                            : activoItem.imagen.name
                                                    }}
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                    <v-tab-item :key="2" :value="`tab-2`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="activoItem.campus_id"
                                                        :items="CAMPUS"
                                                        label="Campus*"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :rules="campusFieldRules"
                                                        :error-messages="campusFieldErrors"
                                                        @blur="campusFieldErrors = []"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="activoItem.departamento_id"
                                                        :items="DEPARTAMENTOS"
                                                        label="Departamento*"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :rules="departamentoFieldRules"
                                                        :error-messages="departamentoFieldErrors"
                                                        @blur="departamentoFieldErrors = []"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-if="activoItem.departamento_id === 3"
                                                        v-model="activoItem.seccion_id"
                                                        :items="
                                                            SECCIONES.filter(
                                                                el => el.campus_id === activoItem.campus_id
                                                            )
                                                        "
                                                        label="Sección*"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :rules="seccionFieldRules"
                                                        :error-messages="seccionFieldErrors"
                                                        @blur="seccionFieldErrors = []"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="activoItem.edificio_id"
                                                        :items="EDIFICIOS"
                                                        label="Edificio"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :error-messages="edificioFieldErrors"
                                                        @blur="edificioFieldErrors = []"
                                                        append-outer-icon="add"
                                                        @click:append-outer="showEdificioForm = true"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="activoItem.area_id"
                                                        :items="AREAS"
                                                        label="Área"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :error-messages="areaFieldErrors"
                                                        @blur="areaFieldErrors = []"
                                                        append-outer-icon="add"
                                                        @click:append-outer="showAreaForm = true"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                    <v-tab-item :key="3" :value="`tab-3`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="activoItem.grupo_id"
                                                        :items="AGRUPOS"
                                                        label="Grupo*"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :rules="grupoFieldRules"
                                                        :error-messages="grupoFieldErrors"
                                                        @blur="grupoFieldErrors = []"
                                                        append-outer-icon="add"
                                                        @click:append-outer="showGrupoForm = true"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="activoItem.tipo_id"
                                                        :items="TIPOS"
                                                        label="Tipo*"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :rules="tipoFieldRules"
                                                        :error-messages="tipoFieldErrors"
                                                        @blur="tipoFieldErrors = []"
                                                        append-outer-icon="add"
                                                        @click:append-outer="showTipoForm = true"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="activoItem.estado_id"
                                                        :items="ESTADOS"
                                                        label="Estado*"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :rules="estadoFieldRules"
                                                        :error-messages="estadoFieldErrors"
                                                        @blur="estadoFieldErrors = []"
                                                        append-outer-icon="add"
                                                        @click:append-outer="showEstadoForm = true"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="activoItem.categoria_id"
                                                        :items="CATEGORIAS"
                                                        label="Categoría*"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :rules="categoriaFieldRules"
                                                        :error-messages="categoriaFieldErrors"
                                                        @blur="categoriaFieldErrors = []"
                                                        append-outer-icon="add"
                                                        @click:append-outer="showCategoriaForm = true"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                    <v-tab-item :key="4" :value="`tab-4`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm12>
                                                    <template>
                                                        <v-container style="max-width: 500px" class="pa-1">
                                                            <v-autocomplete
                                                                v-model="activoItem.responsables_id"
                                                                :items="EMPLEADOS"
                                                                hide-selected
                                                                label="Reponsables"
                                                                multiple
                                                                persistent-hint
                                                                deletable-chips
                                                                chips
                                                                clearable
                                                                item-value="id"
                                                                :error-messages="empleadosFieldErrors"
                                                                @change="empleadosFieldErrors = []"
                                                            >
                                                                <template v-slot:item="data">
                                                                    <v-list-tile-content>
                                                                        {{
                                                                            data.item.nombre +
                                                                                " " +
                                                                                data.item.apellido_paterno +
                                                                                " " +
                                                                                data.item.apellido_materno
                                                                        }}
                                                                    </v-list-tile-content>
                                                                </template>
                                                                <template v-slot:selection="data">
                                                                    <v-chip close @input="removeItem(data.item)">
                                                                        {{
                                                                            data.item.nombre +
                                                                                " " +
                                                                                data.item.apellido_paterno +
                                                                                " " +
                                                                                data.item.apellido_materno
                                                                        }}
                                                                    </v-chip>
                                                                </template>
                                                            </v-autocomplete>
                                                        </v-container>
                                                    </template>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <small class="ml-2">(*) indica campos requeridos</small>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>

        <grupo-form
            v-if="showGrupoForm"
            form-title="Nuevo grupo"
            :initial-item="null"
            @formCanceled="showGrupoForm = false"
        >
        </grupo-form>
        <edificio-form
            v-if="showEdificioForm"
            form-title="Nuevo edificio"
            :initial-item="null"
            @formCanceled="showEdificioForm = false"
        >
        </edificio-form>
        <area-form
            v-if="showAreaForm"
            form-title="Nueva área"
            :initial-item="null"
            @formCanceled="showAreaForm = false"
        >
        </area-form>
        <tipo-form
            v-if="showTipoForm"
            form-title="Nuevo tipo"
            :initial-item="null"
            @formCanceled="showTipoForm = false"
        >
        </tipo-form>
        <estado-form
            v-if="showEstadoForm"
            form-title="Nuevo estado"
            :initial-item="null"
            @formCanceled="showEstadoForm = false"
        >
        </estado-form>
        <categoria-form
            v-if="showCategoriaForm"
            form-title="Nueva categoría"
            :initial-item="null"
            @formCanceled="showCategoriaForm = false"
        >
        </categoria-form>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Util from "@/util"
const GrupoForm = () => import("@/components/finanzas/nomencladores/grupo-form/grupo-form")
const EdificioForm = () => import("@/components/finanzas/nomencladores/edificio-form/edificio-form")
const AreaForm = () => import("@/components/finanzas/nomencladores/area-form/area-form")
const TipoForm = () => import("@/components/finanzas/nomencladores/tipo-form/tipo-form")
const EstadoForm = () => import("@/components/finanzas/nomencladores/estado-form/estado-form")
const CategoriaForm = () => import("@/components/finanzas/nomencladores/categoria-form/categoria-form")

export default {
    components: {
        GrupoForm,
        TipoForm,
        EstadoForm,
        CategoriaForm,
        EdificioForm,
        AreaForm
    },
    props: {
        formTitle: { type: String, default: null },
        initialItem: { type: Object, default: null }
    },
    data() {
        return {
            activeTab: "tab-1",
            loading: false,
            validActivo: false,
            activoItem: {
                codigo: "",
                marca: "",
                modelo: "",
                serie: "",
                descripcion: "",
                fecha_ingreso: this.formatDate(new Date().toISOString().substr(0, 10)),
                fecha_baja: "",
                costo: "",
                imagen: [],

                campus_id: "",
                seccion_id: "",
                departamento_id: null,
                edificio_id: "",
                area_id: "",
                grupo_id: "",
                tipo_id: "",
                estado_id: "",
                categoria_id: "",
                responsables_id: []
            },
            menuFechaIngreso: false,
            menuFechaBaja: false,
            dateFecha_baja: "",
            dateFecha_ingreso: new Date().toISOString().substr(0, 10),

            //validaciones
            codigoFieldRules: [
                v => !!v || "Debe proporcionar un código",
                v => v.length <= 30 || "El código solo puede contener 30 caracteres"
            ],
            codigoFieldErrors: [],
            descripcionFieldRules: [
                v => !!v || "Debe proporcionar una descripción",
                v => v.length <= 255 || "La descripción solo puede contener 255 caracteres"
            ],
            descripcionFieldErrors: [],
            campusFieldRules: [v => !!v || "Debe proporcionar el campus"],
            campusFieldErrors: [],
            departamentoFieldRules: [v => !!v || "Debe proporcionar el departamento"],
            departamentoFieldErrors: [],
            seccionFieldRules: [v => (this.computedDepartamentoSeccion && !!v) || "Debe proporcionar la sección"],
            seccionFieldErrors: [],
            estadoFieldRules: [v => !!v || "Debe proporcionar el estado"],
            estadoFieldErrors: [],

            marcaFieldErrors: [],
            modeloFieldErrors: [],
            serieFieldErrors: [],
            fecha_ingresoFieldErrors: [],
            fecha_bajaFieldErrors: [],
            costoFieldErrors: [],
            imagenFieldErrors: [],
            edificioFieldErrors: [],
            areaFieldErrors: [],
            grupoFieldErrors: [],
            grupoFieldRules: [v => !!v || "Debe proporcionar el grupo"],
            tipoFieldErrors: [],
            categoriaFieldErrors: [],
            empleadosFieldErrors: [],

            //formularios nuevos nomencladores
            showGrupoForm: false,
            showTipoForm: false,
            showEstadoForm: false,
            showCategoriaForm: false,
            showEdificioForm: false,
            showAreaForm: false,
            tipoFieldRules: [v => !!v || "Debe proporcionar el tipo"],
            categoriaFieldRules: [v => !!v || "Debe proporcionar la categoría"],

            //alert errores de validacion
            showErrorAlert: false,

            //saber si se cargaron todos los datos necesarios para el formulario
            showErrorDataLoadedAlert: false
        }
    },
    computed: {
        ...mapGetters([
            "CAMPUS",
            "SECCIONES",
            "DEPARTAMENTOS",
            "AGRUPOS",
            "TIPOS",
            "ESTADOS",
            "CATEGORIAS",
            "EMPLEADOS",
            "AREAS",
            "EDIFICIOS"
        ]),

        isNewRecord() {
            return this.initialItem === null
        },

        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        disableSaveButton() {
            return this.loading || !this.validActivo
        },

        computedDepartamentoSeccion() {
            return this.activoItem.departamento_id === 3
        },

        computedFechaBajaFormatted: {
            get: function() {
                return this.formatDate(this.dateFecha_baja)
            },
            set: function() {
                return (this.activoItem.fecha_baja = "")
            }
        },

        computedFechaIngresoFormatted() {
            return this.formatDate(this.dateFecha_ingreso)
        }
    },

    methods: {
        saveForm() {
            this.loading = true
            this.$refs.activoForm.validate()
            if (this.validActivo) {
                let activo = new FormData()

                if (!this.activoItem.fecha_baja) {
                    this.activoItem.fecha_baja = ""
                }

                Object.entries(this.activoItem).forEach(([key, value]) => {
                    activo.append(key, value)
                })

                if (this.activoItem.imagen !== "") {
                    activo.append("Activo[file]", this.activoItem.imagen)
                }

                if (!this.isNewRecord) {
                    activo.append("id", this.initialItem.id)
                }
                this.$store.dispatch(this.isNewRecord ? "ADD_ACTIVO" : "UPDATE_ACTIVO", activo).then(result => {
                    if (!result) {
                        this.loading = false
                    }
                    if (result === null || result.status === 404) {
                        //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe o no hay coneccion con el servidor
                        this.$emit("formCanceled")
                    } else {
                        // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                        let { data, status } = result
                        if (status === 422) {
                            this.showErrorAlert = true
                            data.forEach(error => {
                                console.log(error.message)
                                switch (error.field) {
                                    case "codigo":
                                        this.codigoFieldErrors.push(error.message)
                                        break
                                    case "marca":
                                        this.marcaFieldErrors.push(error.message)
                                        break
                                    case "modelo":
                                        this.modeloFieldErrors.push(error.message)
                                        break
                                    case "serie":
                                        this.serieFieldErrors.push(error.message)
                                        break
                                    case "descripcion":
                                        this.descripcionFieldErrors.push(error.message)
                                        break
                                    case "fecha_ingreso":
                                        this.fecha_ingresoFieldErrors.push(error.message)
                                        break
                                    case "fecha_baja":
                                        this.fecha_bajaFieldErrors.push(error.message)
                                        break
                                    case "costo":
                                        this.costoFieldErrors.push(error.message)
                                        break
                                    case "imagen":
                                        this.imagenFieldErrors.push(error.message)
                                        break
                                    case "campus_id":
                                        this.campusFieldErrors.push(error.message)
                                        break
                                    case "departamento_id":
                                        this.departamentoFieldErrors.push(error.message)
                                        break
                                    case "seccion_id":
                                        this.seccionFieldErrors.push(error.message)
                                        break
                                    case "edificio_id":
                                        this.edificioFieldErrors.push(error.message)
                                        break
                                    case "area_id":
                                        this.areaFieldErrors.push(error.message)
                                        break
                                    case "grupo_id":
                                        this.grupoFieldErrors.push(error.message)
                                        break
                                    case "tipo_id":
                                        this.tipoFieldErrors.push(error.message)
                                        break
                                    case "estado_id":
                                        this.estadoFieldErrors.push(error.message)
                                        break
                                    case "categoria_id":
                                        this.categoriaFieldErrors.push(error.message)
                                        break
                                    case "empleados":
                                        this.empleadosFieldErrors.push(error.message)
                                        break
                                }
                            })
                        }
                    }
                    this.loading = false
                })
            } else {
                this.loading = false
            }
        },

        cancelForm() {
            this.$emit("formCanceled")
        },

        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split("-")
            return `${day}/${month}/${year}`
        },

        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split("/")
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
        },

        onChangeFileUpload() {
            this.activoItem.imagen = this.$refs.file.files[0]

            if (this.activoItem.imagen !== [] && Util.validateFile(this.activoItem.imagen.name, ["image"])) {
                this.imagenFieldErrors = []
            } else {
                this.activoItem.imagen = []
                this.imagenFieldErrors.push("El archivo seleccionado debe ser una imagen")
            }
        },

        customFilter(item, queryText) {
            const textNombre = item.nombre.toLowerCase()
            const textApellidoPaterno = item.apellido_paterno.toLowerCase()
            const textApellidoMaterno = item.apellido_materno.toLowerCase()
            const searchText = queryText.toLowerCase()

            return (
                textNombre.indexOf(searchText) > -1 ||
                textApellidoPaterno.indexOf(searchText) > -1 ||
                textApellidoMaterno.indexOf(searchText) > -1
            )
        },

        removeItem(item) {
            let index = this.activoItem.responsables_id.findIndex(el => el.id === item.id)
            this.activoItem.responsables_id.splice(index, 1)
        }
    },

    watch: {
        dateFecha_baja: function() {
            this.activoItem.fecha_baja = this.formatDate(this.dateFecha_baja)
        },

        dateFecha_ingreso: function() {
            this.activoItem.fecha_ingreso = this.formatDate(this.dateFecha_ingreso)
        }
    },
    mounted() {
        this.$store.dispatch("LOAD_ALL_CAMPUS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_SECCIONES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_DEPARTAMENTOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_AGRUPOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_CATEGORIAS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_TIPOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_ESTADOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_EMPLEADOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_EDIFICIOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_AREAS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })

        if (this.initialItem !== null) {
            // Cargando información del elemento a actualizar
            this.activoItem = Object.assign({}, this.initialItem)
            this.activoItem.imagen = []
            if (!this.initialItem.grupo_id) {
                this.activoItem.grupo_id = ""
            }
            if (!this.initialItem.tipo_id) {
                this.activoItem.tipo_id = ""
            }
            if (!this.initialItem.categoria_id) {
                this.activoItem.categoria_id = ""
            }
            if (!this.initialItem.estado_id) {
                this.activoItem.estado_id = ""
            }
            if (!this.initialItem.edificio_id) {
                this.activoItem.edificio_id = ""
            }
            if (!this.initialItem.area_id) {
                this.activoItem.area_id = ""
            }

            if (!this.initialItem.costo) {
                this.activoItem.costo = ""
            }

            if (!this.initialItem.seccion_id) {
                this.activoItem.seccion_id = ""
            }

            if (this.initialItem.responsables.length) {
                this.activoItem.responsables_id = []
                this.initialItem.responsables.forEach(responsable =>
                    this.activoItem.responsables_id.push(responsable.id)
                )
            } else this.activoItem.responsables_id = []
        }
    },
    created() {
        if (this.initialItem !== null) {
            // Cargando información del elemento a actualizar
            if (this.initialItem.fecha_ingreso) {
                let [dia, mes, ano] = this.initialItem.fecha_ingreso.split("/")
                this.activoItem.fecha_ingreso = ano + "-" + mes + "-" + dia
                this.dateFecha_ingreso = this.activoItem.fecha_ingreso
            }

            if (this.initialItem.fecha_baja) {
                let [dia2, mes2, ano2] = this.initialItem.fecha_baja.split("/")
                this.activoItem.fecha_baja = ano2 + "-" + mes2 + "-" + dia2
                this.dateFecha_baja = this.activoItem.fecha_baja
            }
        }
    }
}
</script>

<style scoped>
.v-alert {
    padding-top: 3px;
    padding-bottom: 4px;
    margin-top: 1px;
    margin-left: 2px;
    margin-right: 2px;
}

input[type="file"] {
    display: none;
}

.error_message {
    font-size: 12px;
    color: #ff5252;
    caret-color: #ff5252;
}
</style>
